import { ButtonProps, SxProps } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { HeartButton } from "@outschool/ui-components-shared";
import React from "react";
import { useAnalytics } from "use-analytics";

import { useIsActivitySavedByCurrentLearner } from "../queries/LearnerSavedActivitiesQuery";
import {
  useSaveActivityForLearner,
  useUnsaveActivityForLearner,
} from "../queries/LearnerSavedActivityMutations";

interface SaveButtonProps {
  activity: {
    uid: string;
  };
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
  simpleHeart?: boolean;
  color?: string;
  setLabel?: string;
  unsetLabel?: string;
  sx?: SxProps;
  trackingPrefix: string;
  trackingProperties?: { [key: string]: string | number };
  onClick?(hearted: boolean): void;
}

export function SaveButton({
  activity,
  size = "medium",
  variant = "link",
  simpleHeart = false,
  color = "primary",
  setLabel = "Saved",
  unsetLabel = "Save",
  sx = {},
  trackingPrefix,
  trackingProperties = {},
  onClick,
}: SaveButtonProps) {
  const { track } = useAnalytics();
  const isSavedByLearner = useIsActivitySavedByCurrentLearner(activity);

  const { saveActivity, unsaveActivity } = {
    saveActivity: useSaveActivityForLearner(activity),
    unsaveActivity: useUnsaveActivityForLearner(activity),
  };

  const handleHeartClick = React.useCallback(
    async (hearted: $TSFixMe) => {
      if (hearted) {
        await saveActivity(null, null);
        track(
          `${trackingPrefix}.favorite_class.${activity.uid}`,
          trackingProperties,
        );
      } else {
        await unsaveActivity();
        track(
          `${trackingPrefix}.unfavorite_class.${activity.uid}`,
          trackingProperties,
        );
      }
      onClick && onClick(hearted);
    },
    [
      saveActivity,
      unsaveActivity,
      trackingPrefix,
      track,
      activity,
      trackingProperties,
      onClick,
    ],
  );

  const heartButtonProps = {
    color,
    size,
    variant,
    isSet: isSavedByLearner,
    onChange: handleHeartClick,
  };
  return simpleHeart ? (
    <HeartButton
      {...heartButtonProps}
      sx={{
        height: "16px !important",
        textDecoration: "none !important",
      }}
    />
  ) : (
    <HeartButton
      {...heartButtonProps}
      setLabel={setLabel}
      unsetLabel={unsetLabel}
      sx={sx}
    />
  );
}

export default SaveButton;
